
import {
    Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import Multiselect from '@/components/base/form/Multiselect.vue';
import StatTaskedFileItem from '@/components/revenue/statTask/StatTaskedFileItem.vue';
import { addFile } from '@/api';
import {
    IFiles,
    IOfferService,
} from '@/api/types/revenue';
import { showServerError } from '@/utils';
import { eventBus } from '@/eventbus';

@Component({
    components: {
        Multiselect,
        StatTaskedFileItem,
    },
})
export default class StatTaskFiles extends Vue {
    @Prop({ type: Array, default: () => ([]) }) possibleItemsForSelect!: IOfferService[];
    @Prop({ type: String, default: 'id' }) itemValue!: string;

    // Выбранный для загрузки файл
    statTaskedFiles: object[] = [];
    // Выбранные файлы
    addedFiles: IFiles[] = [];
    itemsForSelect: IOfferService[] = [];
    addFileLoader = false;

    @Watch('possibleItemsForSelect')
    changeItemsForSelect(value: IOfferService[]): void {
        this.itemsForSelect = [...value];
    }

    created(): void {
        this.itemsForSelect = [...this.$props.possibleItemsForSelect];
        // чтобы при сохранении счета не потерять добавленные, но не сохраненные файлы
        eventBus.$on('save', this.addFiles);
        this.addBlankItem();
    }

    beforeDestroy(): void {
        eventBus.$off('save', this.addFiles);
    }

    get isAddFileButtonDisabled(): boolean {
        return this.addedFiles?.some((item) => item.offer_services!.length! <= 0);
    }

    async getFiles(): Promise<void> {
        try {
            this.addedFiles = [];
            const input = this.$el.querySelector('.stat-task__file-input input') as HTMLElement;
            if (input) {
                input.blur();
            }
            this.addFileLoader = true;
            if (this.statTaskedFiles.length) {
                for (const fl of this.statTaskedFiles) {
                    const fileForStatTask = {} as IFiles;
                    this.$set(fileForStatTask, 'offer_services', []);
                    this.$set(fileForStatTask, 'comments', []);

                    const { data: { data: file } } = await addFile(fl);
                    this.$set(fileForStatTask, 'file', file);
                    this.addedFiles.push(fileForStatTask);
                }
            } else {
                this.addBlankItem();
            }
        } catch (err) {
            showServerError(err, 'Файл не найден');
        } finally {
            this.addFileLoader = false;
            this.itemsForSelect = [...this.$props.possibleItemsForSelect];
        }
    }

    updatePossibleItemsForSelect(arr: IOfferService[]): void {
        this.itemsForSelect = arr;
    }

    // удалить выбранный файл
    async removeDocumentFile(item: IFiles, index: number): Promise<void> {
        this.addedFiles.splice(index, 1);
        this.itemsForSelect = this.itemsForSelect.concat(item!.offer_services!);
        !this.addedFiles.length && this.addBlankItem();
    }

    addBlankItem(): void {
        const fileForStatTask = {} as IFiles;
        this.$set(fileForStatTask, 'offer_services', []);
        this.$set(fileForStatTask, 'comments', []);
        this.addedFiles.push(fileForStatTask);
    }

    async addFiles(): Promise<void> {
        if (!this.addedFiles.length) {
            return;
        }
        await this.$emit('add-files', this.addedFiles);
        this.addedFiles = [];
        this.statTaskedFiles = [];
        this.addBlankItem();
        eventBus.$emit('clear-comments');
    }
}
